import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import AuthModule from "./modules/auth";
import OrderModule from "@/store/modules/order";
import MenuModule from "@/store/modules/menu";
import OptionModule from "@/store/modules/option";
import SetMenuItemModule from "@/store/modules/setMenuItem";
import MenuSetModule from "@/store/modules/menuSet";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

function vuexPersistPatch() {
  return (store) => {
    store._vm.$root.$data["vue-persist-patch-delay"] = true;

    store.subscribe((mutation) => {
      if (mutation.type === "RESTORE_MUTATION") {
        store._vm.$root.$data["vue-persist-patch-delay"] = false;
        store._vm.$root.$emit("storageReady");
      }
    });
  };
}

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  restoreState: (key, storage) => {
    const state = storage.getItem("vuex");
    const data = JSON.parse(state);

    return data;
  },
});

const store = new Vuex.Store({
  modules: {
    Auth: AuthModule,
    OrderStore: OrderModule,
    MenuStore: MenuModule,
    OptionStore: OptionModule,
    SetMenuItemStore: SetMenuItemModule,
    MenuSetStore: MenuSetModule,
  },
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
  },
  plugins: [vuexLocal.plugin, vuexPersistPatch()],
  strict: debug,
});

export default store;
